import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchIncomeStatements } from '../query-api'
import { IncomeStatementsReportOptions } from '../types/reportOptions'

export const useFetchIncomeStatementsReport = (options?: IncomeStatementsReportOptions) => {
  const { organization } = useUserOrganization()

  const { data, ...rest } = useQuery(
    [QueryKeys.IncomeStatements, { organizationId: organization?.id, ...options }],
    () => fetchIncomeStatements({ organizationId: organization?.id as string, options }),
    {
      enabled: !!organization?.id && organization.countryId !== 'NL',
      staleTime: defaultStaleTime,
    },
  )

  return { report: data?.report, ...rest }
}
